import { Component } from '@angular/core';

@Component({
  selector: 'app-header-monitor',
  templateUrl: './header-monitor.component.html',
  styleUrls: ['./header-monitor.component.scss'],
})
export class HeaderMonitorComponent {}
